import React from 'react';
import ReactDOM from 'react-dom';
import 'react-datepicker/dist/react-datepicker.css';

import './main.css';
import AppShell from './components/App';

ReactDOM.render(<AppShell />, document.getElementById('root'));
